import { memo } from "react";
import { useNavigate } from "react-router-dom";

const Navbar = memo(function Navbar({
  canSave,
  userData,
  handleSubmit,
  isProcessing,
  saveSuccess,
}) {

  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Left Side: Back Button and Title */}
          <div className="flex items-center gap-2">
            <button
              onClick={handleBackClick}
              className="w-8 h-8 flex items-center justify-center text-black"
              aria-label="Go back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
            </button>
            <h1 className="text-xl font-bold text-gray-900">Edit Profile</h1>
          </div>

          {/* Right Side: Instagram-style Action Button */}
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!canSave || isProcessing}
            className="flex items-center justify-center transition-all active:scale-90 disabled:opacity-30 disabled:cursor-not-allowed"
          >
            {isProcessing ? (
              <div className="w-5 h-5 border-[1.5px] border-[#6b8f3a] border-t-transparent rounded-full animate-spin" />
            ) : (
              <div
                className={
                  saveSuccess
                    ? "text-green-600"
                    : "text-[#6b8f3a] hover:text-[#5a7a30]"
                }
              >
                <svg
                  className="w-7 h-7 transition-colors" // Reduced from w-8 to w-7
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2} // Reduced from 3 to 2 for a cleaner line
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
});

export default Navbar;